import { env } from '@skin-seoul/env-utils';
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import qs from 'qs';

const DEFAULT_WORDPRESS_URL = 'https://skin-seoul.com';

const getWordpressBaseURL = (): string => {
  if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
    return env('NEXT_PUBLIC_ENV_CLOUDFLARE_IMAGE_ORIGIN') || DEFAULT_WORDPRESS_URL;
  }
  return env('NEXT_PUBLIC_ENV_FRONTEND_ORIGIN') || DEFAULT_WORDPRESS_URL;
};

export const createSkinSeoulWordpressClient = (_baseURL?: string): AxiosInstance => {
  const initialBaseURL = _baseURL || getWordpressBaseURL();

  const isServer = typeof window === 'undefined';

  console.debug('[service/wordpressClient] Creating WordPress HTTP client:', {
    isServer,
    baseURL: initialBaseURL,
  });

  const instance = axios.create({
    baseURL: initialBaseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });

  instance.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
      const currentBaseURL = getWordpressBaseURL();
      const configBaseURL = config.baseURL || instance.defaults.baseURL;

      if (currentBaseURL !== DEFAULT_WORDPRESS_URL && configBaseURL !== currentBaseURL) {
        console.warn('[service/wordpressClient] Race condition detected - fixing baseURL:', {
          from: configBaseURL,
          to: currentBaseURL,
        });
        config.baseURL = currentBaseURL;
        instance.defaults.baseURL = currentBaseURL;
      }
    }
    return config;
  });

  return instance;
};

export let wordpressClient: AxiosInstance = createSkinSeoulWordpressClient();

export const setWordpressClient = (instance: AxiosInstance) => {
  wordpressClient = instance;
};
